import {h, Component} from 'preact';
import {Field} from 'formik';
import cx from 'classnames';
import {Label, Hint, InputFeedback} from '../index';

export class Textarea extends Component {

    componentDidMount () {
        if ( this.props.isFocused ) {
            setTimeout( () => this.field && this.field.focus(), 10 )
        }
    }

    render ( {id, name, label, hint, error, errorShown, value, onChange, onBlur, className, inputClassName, children, ...props} ) {

        const groupClasses = cx(
            'textarea-group',
            className,
            {
                'animated shake error': !!error || !!errorShown
            }
        );

        const inputClasses = cx(
            'textarea',
            {'disabled': props.disabled},
            inputClassName
        );

        return (
            <div className={groupClasses}>
                {label &&
                <Label htmlFor={id} error={error}>
                    {label}
                </Label>
                }
                {hint &&
                <Hint htmlFor={id} error={error}>
                    {hint}
                </Hint>
                }
                <Field
                    tabIndex={0}
                    component="textarea"
                    innerRef={ref => this.field = ref}
                    id={id}
                    name={name || id}
                    className={inputClasses}
                    onBlur={onBlur}
                    onChange={onChange}
                    value={value}
                    {...props}>
                    {children}
                </Field>
                <InputFeedback error={error}/>
            </div>
        );
    };
}
